import {apiRegister} from '../../common/api';

import {isNumber, isArray} from '../../common/utils';
import {ERR_REP_GAME_LIST, ERR_REQ_CUP_ID} from '../../common/const';

/*
协议Id 
374
项目 
模块 
方式 
https 
命令（路径） 
/award/klinev1/gamelist/
说明
斗k 我的战斗列表
请求参数
参数名称	参数类型	说明
cupId	int	
uid	int	
start	int	（可选）默认0
pageNum	int	(可选）默认20
beforeId	int	默认0
afterId	int	默认为0
totalFlag	int	是否获取总数 默认为0
*/

// const dkGames = apiRegister('dk-games', {
//   protoId: 374,
//   path: '/award/klinev1/gamelist/',
//   checkQuery(Q) {
//     if (!isNumber(Q.cupId)) {
//       return ERR_REQ_CUP_ID; // 参数错误
//     }
//     return 0;
//   },
//   checkResult({list}) {
//     if (!isArray(list)) {
//       return ERR_REP_GAME_LIST; // 数据格式非法
//     }
//     return 0;
//   }
// });

/*
协议Id 
920
项目 
模块 
方式 
https 
命令（路径） 
/award/match/mygames/
说明
我的初赛斗K记录
请求参数
参数名称	参数类型	说明
cupId	int	场id
*/
const dkGames = apiRegister('dk-games', {
  protoId: 920,
  path: '/award/match/mygames/',
  checkQuery(Q) {
    if (!isNumber(Q.cupId)) {
      return ERR_REQ_CUP_ID; // 参数错误
    }
    return 0;
  },
  checkResult({list}) {
    if (!isArray(list)) {
      return ERR_REP_GAME_LIST; // 数据格式非法
    }
    return 0;
  }
});

// 接口
export const dkGamesLoad = dkGames.send;
